import fraud from '@flowio/fraud';
import session from '@flowio/session';

export default function initFraud() {
  const shouldLoadFraudBeacon = !!(session.getSessionId() && session.getExperience());
  if (shouldLoadFraudBeacon && window.Flow.fraud === 'enabled') {
    fraud.init();
  }
}



// WEBPACK FOOTER //
// ./static/js/v0/initFraud.js